<template>
  <div :style="`height: ${mapHeight}px; width: 100%`">
    <l-map :zoom="zoom" :center="center" :options="mapOptions" style="height: 100%">
      <l-tile-layer :url="url" :attribution="attribution"/>
        <l-marker :lat-lng.sync="marker.position" :icon="createIcon(marker)" :draggable="marker.draggable"></l-marker>
    </l-map>
  </div>
</template>

<script>
import { latLng, icon, Path } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip} from "vue2-leaflet";

export default {
  name: "Locator",
  props: {
    mapHeight: String,
    icons: Object,
    marker: Object,
    centerLatitude: Number,
    centerLongitude: Number,
    zoom: Number,
    mapKey: String
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip
  },
  data() {
    return {
        mapTile: 'dark',
        url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: { zoomSnap: 0.25, zoomControl: true },
        tiles: {
            terrain: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg',
            dark: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            toner: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png',
            general: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            watercolor: 'https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg'
        }
    };
  },
  methods: {
    setMapTile(mapTile){
        this.mapTile = mapTile
        this.url = this.tiles[this.mapTile] + '?api_key=' + String(this.mapKey)
    },
    createIcon(iconData){
        return icon({
            iconUrl: this.icons[iconData.icon],
            iconSize: iconData.size,
            iconAnchor: iconData.anchor
        })
    },
    sendLocation(){ 
      return { lat: this.marker.position.lat, lng:this.marker.position.lng }
    }
  },
  computed: {
    center(){
      return latLng(this.centerLatitude, this.centerLongitude)
    }
  },
  mounted(){
    this.setMapTile(this.mapTile)
  }
};
</script>
